import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import { NAV_ITEMS } from '../data/site';

const navLinkClass = ({ isActive }) =>
  `alt4-nav-link${isActive ? ' alt4-nav-link--active' : ''}`;

export default function Alt4Nav() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 12);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!window.matchMedia) return undefined;

    const desktopViewport = window.matchMedia('(min-width: 881px)');
    const closeOnDesktop = ({ matches }) => {
      if (matches) setMobileOpen(false);
    };

    closeOnDesktop(desktopViewport);
    desktopViewport.addEventListener?.('change', closeOnDesktop);
    desktopViewport.addListener?.(closeOnDesktop);

    return () => {
      desktopViewport.removeEventListener?.('change', closeOnDesktop);
      desktopViewport.removeListener?.(closeOnDesktop);
    };
  }, []);

  return (
    <header className={`alt4-header${scrolled ? ' alt4-header--scrolled' : ''}`}>
      <nav className="alt4-nav alt4-container" aria-label="Primary navigation">
        <Link className="alt4-wordmark" to="/alt4" aria-label="Asha AI-native PMS home">
          <span className="alt4-wordmark-name">asha</span>
          <span className="alt4-wordmark-product">AI-native PMS</span>
        </Link>

        <div className="alt4-nav-desktop">
          <div className="alt4-nav-links">
            {NAV_ITEMS.map((item) => (
              <NavLink key={item.to} className={navLinkClass} to={item.to}>
                {item.label}
              </NavLink>
            ))}
          </div>
          <Link className="alt4-button alt4-button--small" to="/alt4/walkthrough">
            Book a walkthrough
            <ArrowUpRight size={16} strokeWidth={2} aria-hidden="true" />
          </Link>
        </div>

        <button
          className="alt4-menu-button"
          type="button"
          aria-label={mobileOpen ? 'Close navigation' : 'Open navigation'}
          aria-expanded={mobileOpen}
          aria-controls="alt4-mobile-navigation"
          onClick={() => setMobileOpen((open) => !open)}
        >
          {mobileOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </button>
      </nav>

      <nav
        id="alt4-mobile-navigation"
        className="alt4-mobile-navigation"
        aria-label="Mobile navigation"
        hidden={!mobileOpen}
      >
        <div className="alt4-container alt4-mobile-navigation-inner">
          {NAV_ITEMS.map((item) => (
            <NavLink key={item.to} className={navLinkClass} to={item.to}>
              {item.label}
            </NavLink>
          ))}
          <Link className="alt4-button" to="/alt4/walkthrough">
            Book a walkthrough
            <ArrowUpRight size={17} strokeWidth={2} aria-hidden="true" />
          </Link>
        </div>
      </nav>
    </header>
  );
}
